export default __webpack_public_path__ + "static/N0032-3b41d084ac0b7de4026ba1b6d56c14f4.png";